<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-02-14 23:36:16
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-06-10 22:52:09
-->
<template>
  <veStuGraduation viewType="yx" print slot="table"></veStuGraduation>
</template>

<script>
import veStuGraduation from './base/veStuGraduation';
export default {
  components: {
    veStuGraduation
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped></style>
